import { render, staticRenderFns } from "./EmployeeCaseloadEditor.vue?vue&type=template&id=ce5ec0ce&scoped=true&"
import script from "./EmployeeCaseloadEditor.vue?vue&type=script&lang=js&"
export * from "./EmployeeCaseloadEditor.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeCaseloadEditor.vue?vue&type=style&index=0&id=ce5ec0ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5ec0ce",
  null
  
)

export default component.exports